import styled from "styled-components";

export const DarkModal = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    flex-direction: column;
    align-ittems: center;
    justify-content: center;
    position: absolute;
    z-index:20000;
`
export const TableBlock = styled.table`
    width: 100%;
    text-align: center;
    vertical-align: middle;
    border: 0.5px solid rgb(100,100,100);
    -webkit-box-shadow: 1.5px 1.5px 2px 0px #000000;
            box-shadow: 1.5px 1.5px 2px 0px #000000;
`